export const removeCountryPrefix = (promoCode: string, countryISOCode) => {
    if (!promoCode) {
        return "";
    }

    if (promoCode.startsWith(countryISOCode)) {
        return promoCode.substring(countryISOCode.length);
    }
    return promoCode;
};
